import { useCallback, useEffect, useRef } from 'react'

import { TopScrollbar } from './TopScrollbar'

import type { RefObject } from 'react'

type Return = {
  onSourceScroll: () => void
  sourceRef: RefObject<HTMLDivElement | null>
  TopScrollbar: React.JSX.Element
}

export const useTopScrollbar = (): Return => {
  const sourceRef = useRef<HTMLDivElement>(null)
  const scrollbarRef = useRef<HTMLDivElement>(null)
  const widthRef = useRef<HTMLDivElement>(null)

  const onScroll = useCallback(() => {
    if (sourceRef.current && scrollbarRef.current) {
      sourceRef.current.scrollLeft = scrollbarRef.current.scrollLeft
    }
  }, [])

  const onSourceScroll = useCallback(() => {
    if (sourceRef.current && scrollbarRef.current) {
      scrollbarRef.current.scrollLeft = sourceRef.current.scrollLeft
    }
  }, [])

  useEffect(() => {
    const updateScrollbarWidth = () => {
      if (sourceRef.current && widthRef.current) {
        widthRef.current.style.width = `${sourceRef.current.scrollWidth}px`
      }
    }

    updateScrollbarWidth()

    const resizeObserver = new ResizeObserver(updateScrollbarWidth)

    if (sourceRef.current?.firstElementChild) {
      resizeObserver.observe(sourceRef.current.firstElementChild)
    }

    return () => {
      resizeObserver.disconnect()
    }
  }, [])

  return {
    onSourceScroll,
    sourceRef,
    TopScrollbar: (
      <TopScrollbar
        handleScroll={onScroll}
        ref={scrollbarRef}
        widthRef={widthRef}
      />
    ),
  }
}
